/**
 * Offline-first cache for the user's upcoming bookings (with access codes).
 * Strategy:
 *  1) Try network (axios) -> on success, persist to IndexedDB and return fresh data.
 *  2) On failure, return cached data with `fromCache=true` and the cache timestamp.
 */

import axios from 'axios';
import { idbGet, idbSet } from './idb';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = 'bookings:me';

export async function fetchMyBookings(token) {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  try {
    const res = await axios.get(`${API}/bookings`, { headers, withCredentials: true });
    const payload = {
      bookings: Array.isArray(res.data) ? res.data : [],
      cachedAt: new Date().toISOString(),
    };
    await idbSet(KEY, payload);
    return { ...payload, fromCache: false };
  } catch (err) {
    const cached = await idbGet(KEY);
    if (cached) {
      return { ...cached, fromCache: true, error: err };
    }
    throw err;
  }
}

export async function getCachedBookings() {
  const cached = await idbGet(KEY);
  return cached || { bookings: [], cachedAt: null };
}
